export default "__VITE_ASSET__DYFWXzxx__"